import React from 'react';
import { useNavigate } from 'react-router-dom';

export const NoAgendamientoEmbed: React.FC = () => {
  const navigate = useNavigate();
  const search = typeof window !== 'undefined' ? window.location.search : '';
  const params = new URLSearchParams(search);
  const processId = params.get('process_id') || '';
  const patientEmail = params.get('patient_email') || '';
  const patientName = params.get('patient') || '';
  const psychologistEmail = params.get('psychologist_email') || '';
  const totalSessionsGrade = params.get('total_sessions') || '';
  const tallyBase = 'https://tally.so/embed/nPX6J1';
  const tallyParams = new URLSearchParams({
    transparentBackground: '1',
  });
  if (processId) tallyParams.set('process_id', processId);
  if (patientEmail) tallyParams.set('patient_email', patientEmail);
  if (patientName) tallyParams.set('patient', patientName);
  if (psychologistEmail) tallyParams.set('psychologist_email', psychologistEmail);
  if (totalSessionsGrade) tallyParams.set('total_sessions', totalSessionsGrade);
  const tallySrc = `${tallyBase}?${tallyParams.toString()}`;

  return (
    <>
      <button
        type="button"
        onClick={() => { window.history.length > 1 ? navigate(-1) : navigate('/patients'); }}
        style={{
          position: 'fixed',
          top: '4.5rem',
          left: '1rem',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '0.375rem',
          padding: '0.5rem 1rem',
          background: '#fff',
          color: '#374151',
          border: '1px solid #d1d5db',
          borderRadius: '9999px',
          fontSize: '0.875rem',
          fontWeight: 700,
          cursor: 'pointer',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          zIndex: 200,
          transition: 'all 0.2s',
        }}
        onMouseEnter={(e) => { e.currentTarget.style.background = '#f3f4f6'; e.currentTarget.style.borderColor = '#9ca3af'; }}
        onMouseLeave={(e) => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.borderColor = '#d1d5db'; }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="15 18 9 12 15 6" />
        </svg>
        Volver
      </button>
      <div style={{ maxWidth: '1000px', margin: '0 auto', padding: 0 }}>
        <style>{`
          .admin-header-modern { box-shadow: none !important; }
          .admin-tabs { border-bottom: none !important; }
          .tally-embed-frame { display:block; width:100%; min-height: 78vh; border:0; }
          @media (max-width: 640px) { .tally-embed-frame { min-height: 84vh; } }
        `}</style>
        <iframe
          className="tally-embed-frame"
          src={tallySrc}
          loading="lazy"
          title="Pacientes que no quedaron agendados"
          allow="fullscreen; clipboard-read; clipboard-write; camera; microphone"
          style={{ pointerEvents: 'auto' }}
        />
      </div>
    </>
  );
};

export default NoAgendamientoEmbed;
